import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  FiHome, 
  FiHeart,
  FiUser, 
  FiCamera,
  FiUsers
} from 'react-icons/fi';

const Navbar = () => {
  const navItems = [
    { path: '/', icon: FiHome, label: 'Home' },
    { path: '/lab', icon: FiCamera, label: 'Aesthetic' },
    { path: '/mood', icon: FiHeart, label: 'Mood' },
    { path: '/support-system', icon: FiUsers, label: 'Community' },
    { path: '/profile', icon: FiUser, label: 'Profile' }
  ];

  return (
    <div className="fixed bottom-6 left-0 right-0 z-50 px-6 safe-bottom">
      <nav className="max-w-md mx-auto glass rounded-3xl p-2 shadow-2xl border border-[var(--glass-border)]">
        <div className="flex justify-between items-center px-1">
          {navItems.map(({ path, icon: Icon, label }) => (
            <NavLink
              key={path}
              to={path}
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center flex-1 py-2 px-1 rounded-2xl transition-all duration-300 ${
                  isActive 
                    ? 'text-white' 
                    : 'text-[var(--text-muted)] hover:text-[var(--text-primary)]'
                }`
              }
            >
              {({ isActive }) => (
                <div className="flex flex-col items-center gap-1 w-full">
                  <div
                    className="relative z-10 flex items-center justify-center transition-transform duration-150 hover:scale-110 active:scale-90"
                  >
                    <Icon size={isActive ? 22 : 20} strokeWidth={isActive ? 2.5 : 2} />
                  </div>
                  <span className={`text-[10px] font-black uppercase tracking-tighter transition-all ${isActive ? 'opacity-100 text-white z-10' : 'opacity-75'}`}>
                    {label}
                  </span>
                  
                  {isActive && (
                    <div
                      className="absolute inset-0 bg-[linear-gradient(135deg,var(--accent-primary),var(--accent-secondary))] rounded-2xl shadow-[0_4px_12px_var(--accent-glow)] border border-[var(--glass-border)]"
                    />
                  )}
                </div>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
